import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ceb9630c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_4 = { class: "modal-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "¿Estás seguro de que deseas borrar este Post?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Esta acción no se puede deshacer", -1))
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mis Posts", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Gestionar Mi Canal", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { class: "search-form" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = { class: "table-container" }
const _hoisted_14 = { class: "modern-table" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Imagen"),
    /*#__PURE__*/_createElementVNode("th", null, "Título"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_16 = ["src"]

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelService from '@/services/ChannelService'
import { onMounted, ref, Ref } from 'vue';
import {useAuth} from '@/store/useAuth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import main from '@/data/main.js';
import CodeI from '@/interfaces/CodeBiteInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodePostAllAuth',
  setup(__props) {

const service = new ChannelService()
const items:Ref<CodeI[]> = ref([])
const filtered:Ref<CodeI[]> = ref([])
const loading = ref(false)
const search = ref('')
const store = useAuth()
const toast = useToast()
const showDelete = ref(false)
const toDelete = ref()

onMounted(async () => {
    if(!store.token) { return}
    loading.value = true
    items.value = await service.GetLatestCodePostsFromAuthUser(store.token, 1000000)
    filtered.value = items.value
    loading.value = false
})

const readMore = (id:string | undefined) => {
    router.push({name: 'codepost-view', params: {id: id}})
}

const prepareToDelete = (id:string | undefined) => {
    toDelete.value = id;
    showDelete.value=true
}

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter(item => item.title?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

const handleDelete = async () => {
    if(!store.token) {
        toast.showToast("Debes acceder con tu cuenta o registrarte para realizar esta acción", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await service.DeleteCodePost(store.token, toDelete.value)
    if(response.success) {
        toast.showToast("Post Borrado", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000)
        items.value = await service.GetLatestCodePostsFromAuthUser(store.token, 1000000)
        filtered.value = items.value
        search.value = ""
        showDelete.value = false
        return
    } else {
        toast.showToast(response.message, Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        showDelete.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showDelete.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      style: {"float":"right","cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showDelete.value = false))
                    }, [
                      _createVNode(_component_v_icon, {
                        name: "ri-close-circle-fill",
                        fill: "lightcoral"
                      })
                    ]),
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "new-question",
                        onClick: handleDelete,
                        style: {"background-color":"lightcoral","color":"white"}
                      }, "Borrar Post"),
                      _createElementVNode("button", {
                        class: "new-question",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showDelete.value = false))
                      }, "Cancelar")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_8,
            _createVNode(_component_RouterLink, {
              to: { name: 'social-profile-edit' },
              style: {"text-decoration":"none"}
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _hoisted_10,
            _createElementVNode("form", _hoisted_11, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("img", {
                          src: item.image_uri,
                          width: "100"
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.title), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_v_icon, {
                          name: "md-fileopen-round",
                          class: "ver",
                          fill: _unref(main).SECONDARY_COLOR,
                          scale: "2",
                          onClick: ($event: any) => (readMore(item.id))
                        }, null, 8, ["fill", "onClick"]),
                        _createVNode(_component_v_icon, {
                          name: "ri-forbid-fill",
                          class: "ver",
                          fill: "lightcoral",
                          scale: "2",
                          onClick: ($event: any) => (prepareToDelete(item.id))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})